// extracted by mini-css-extract-plugin
export default {"historyInfo":"History_historyInfo__O4DNO"};